import createReducer from "../utilities/create-reducer";
import * as constants from "../constants/builder-errors";

const initialState = { areShown: false };

export default createReducer(initialState, {
  [constants.HIDE_ERRORS](state, action) {
    return { ...state, areShown: false };
  },
  [constants.SHOW_ERRORS](state, action) {
    return { ...state, areShown: true };
  },
});
